define([
	"dojo/_base/declare",
	"dojo/Deferred",
	"dojo/has",
	"underscore",
	"csi/service/openTelemetryService"
], function (declare, Deferred, has, _, { bindToActiveContext }) {

	const trackingStub = {
		_add: _.noop,
		_remove: _.noop,
		addImageTime: _.noop,
		addServerTime: _.noop,
	};

	return declare(null, {
		// Integer: unique id of this Deferred
		// id: null,

		// Deferred: dojo deferred object representing request
		// reqDfd: null,

		// Deferred: dojo deferred object to wrap
		// _d: null,

		// tracking API - filled in by DeferredTracking to remove circular reference
		_tracking: trackingStub,

		constructor: function (/*Function?*/canceller) {
			this._d = new Deferred(canceller);
			this._id = this._tracking._add(this);

			if (has("csi-debug-deferreds")) {
				this._debugErr = new Error();
			}
		},

		isResolved: function () {
			return this._d.isResolved();
		},

		isRejected: function () {
			return this._d.isRejected();
		},

		isFulfilled: function () {
			return this._d.isFulfilled();
		},

		isCanceled: function () {
			return this._d.isCanceled();
		},

		resolve: function (res) {
			var promise = this._d.resolve(res);

			// deferred has completed processing, so stop tracking
			if (this._id)
				this._tracking._remove(this);

			return promise;
		},

		reject: function (res) {
			var promise = this._d.reject(res);

			// deferred has completed processing, so stop tracking
			if (this._id) {
				this._tracking._remove(this);
			}

			return promise;
		},

		then: function (/*Function?*/resolvedCallback, /*Function?*/errorCallback, /*Function?*/progressCallback) {
			resolvedCallback = bindToActiveContext(resolvedCallback);
			errorCallback = bindToActiveContext(errorCallback);
			progressCallback = bindToActiveContext(progressCallback);
			return this._d.then(resolvedCallback, errorCallback, progressCallback);
		},

		cancel: function () {
			if (!this.isCanceled()) {
				if (this.reqDfd) {
					this.reqDfd.cancel();
				}

				this._d.cancel();
				this.endTimer();
			}

			if (this._id) {
				this._tracking._remove(this);
			}
		},

		progress: function (update) {
			return this._d.progress(update);
		},

		// additional API functions for Centric
		startTimer: function () {
			this.timeStart = new Date().valueOf();
		},

		endTimer: function (bImage) {
			if (!this.timeEnd) {
				this.timeEnd = new Date().valueOf();
				this.timeDiff = this.timeEnd - this.timeStart;

				if (this._id) {
					if (bImage) {
						this._tracking.addImageTime(this.timeDiff);
					} else {
						this._tracking.addServerTime(this.timeDiff);
					}
				}
			}
		}
	});
});